// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__vsuN7","question":"Question_question__LS57h","description":"Question_description__20h6P"};